import { ODSCheckbox } from 'kfone-component-library';
import type { RtiCalculationMethodologyState } from 'model/interfaces/rti-template';
import { useTranslation } from 'react-i18next';
import { METHODOLOGY_I18N_KEYS } from 'utilities/rti-calculation-methodology';

export type RtiCalculationMethodologyProps = {
  value: RtiCalculationMethodologyState;
  onChange: (next: RtiCalculationMethodologyState) => void;
  disabled?: boolean;
};

export function RtiCalculationMethodology({ value, onChange, disabled }: RtiCalculationMethodologyProps) {
  const { t } = useTranslation();

  const setOptionChecked = (key: string, checked: boolean) => {
    onChange({
      options: value.options.map((o) => (o.key === key ? { ...o, checked } : o)),
    });
  };

  return (
    <section className='flex flex-col gap-4' aria-labelledby='rti-calculation-methodology-title'>
      <h3
        id='rti-calculation-methodology-title'
        className='font-ods-font-family-secondary text-ods-font-styles-body-regular-small font-bold text-[#1D1D1D]'
      >
        {t('pe.settings.rti.methodology.title')}
      </h3>
      <p className='-mt-2 font-ods-font-family-secondary text-ods-font-styles-body-regular-small font-normal text-[#1D1D1D]'>
        {t('pe.settings.rti.methodology.helper')}
      </p>
      <div className={`flex flex-col gap-4 ${disabled ? 'pointer-events-none opacity-60' : ''}`}>
        {value.options.map((opt) => {
          const i18nKey = METHODOLOGY_I18N_KEYS[opt.key];
          const label = i18nKey ? t(i18nKey, { defaultValue: opt.label }) : opt.label;
          return (
            <div key={opt.key} className='flex flex-col gap-1'>
              <ODSCheckbox
                id={`rti-calculation-methodology-${opt.key}`}
                checkList={[
                  {
                    label,
                    value: opt.key,
                    checked: opt.checked,
                  },
                ]}
                onChange={(checkbox) => {
                  setOptionChecked(opt.key, checkbox?.checked ?? false);
                }}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
